/**
 * Camerino Virtuale — Virtual Try-On Widget v2.0
 * Production-ready: toast errors, progress bar, mobile responsive
 */
(function () {
  "use strict";

  const API_HOST = "https://camerino-virtuale-production.up.railway.app";

  /* ══════════════════════════════════════════════
     STATO
  ══════════════════════════════════════════════ */
  const state = {
    photoFile:    null,
    photoDataUrl: null,
    product:      null,
    resultUrl:    null,
    resultBase64: null,
    loading:      false,
  };

  /* ══════════════════════════════════════════════
     HTML MODALE
  ══════════════════════════════════════════════ */
  function buildHTML() {
    return `
<div id="cvr-root" role="dialog" aria-modal="true" aria-label="Camerino Virtuale">
  <div id="cvr-backdrop"></div>
  <div id="cvr-modal">

    <!-- Header -->
    <div id="cvr-header">
      <div id="cvr-header-left">
        <span id="cvr-logo">👗</span>
        <div>
          <div id="cvr-title">Camerino Virtuale</div>
          <div id="cvr-subtitle">Prova il vestito su di te</div>
        </div>
      </div>
      <button id="cvr-close" aria-label="Chiudi">✕</button>
    </div>

    <!-- Progress bar -->
    <div id="cvr-progress-bar"><div id="cvr-progress-fill"></div></div>

    <!-- Corpo -->
    <div id="cvr-body">

      <!-- Colonna sinistra: foto utente -->
      <div id="cvr-left">
        <div id="cvr-photo-area">

          <!-- Upload zone -->
          <div id="cvr-upload-zone">
            <div id="cvr-upload-icon">📷</div>
            <div id="cvr-upload-title">Carica la tua foto</div>
            <div id="cvr-upload-sub">Foto frontale in buona luce</div>
            <button id="cvr-upload-btn" type="button">Scegli foto</button>
            <div id="cvr-upload-hint">JPG, PNG, WEBP · max 10MB</div>
          </div>

          <!-- Foto caricata -->
          <img id="cvr-user-photo" alt="La tua foto" style="display:none" />

          <!-- Loading AI -->
          <div id="cvr-loading" style="display:none">
            <div id="cvr-spinner-ring"></div>
            <div id="cvr-loading-title">L'AI sta elaborando…</div>
            <div id="cvr-loading-sub">Circa 30-60 secondi</div>
          </div>

          <!-- Risultato AI -->
          <div id="cvr-result-area" style="display:none">
            <img id="cvr-result-img" alt="Risultato Try-On" />
            <div id="cvr-result-badge">✨ AI Try-On</div>
            <button id="cvr-retry-btn" type="button">↺ Cambia foto</button>
          </div>

        </div>
      </div>

      <!-- Colonna destra: prodotto -->
      <div id="cvr-right">
        <div id="cvr-product-section">
          <div class="cvr-label">PRODOTTO SELEZIONATO</div>
          <div id="cvr-product-name"></div>
          <div id="cvr-thumbs"></div>
        </div>

        <div id="cvr-size-section">
          <div class="cvr-label">TAGLIA</div>
          <div id="cvr-sizes"></div>
        </div>

        <div id="cvr-guide-section">
          <div class="cvr-label">GUIDA TAGLIE</div>
          <table id="cvr-guide-table">
            <tr><th>Taglia</th><th>Petto</th><th>Vita</th><th>Fianchi</th></tr>
            <tr><td>XS</td><td>80–84</td><td>62–66</td><td>87–91</td></tr>
            <tr><td>S</td><td>84–88</td><td>66–70</td><td>91–95</td></tr>
            <tr><td>M</td><td>88–92</td><td>70–74</td><td>95–99</td></tr>
            <tr><td>L</td><td>92–96</td><td>74–78</td><td>99–103</td></tr>
            <tr><td>XL</td><td>96–100</td><td>78–82</td><td>103–107</td></tr>
          </table>
        </div>

        <div id="cvr-actions">
          <button id="cvr-add-cart" type="button" disabled>Aggiungi al carrello</button>
          <button id="cvr-save" type="button" style="display:none">Salva foto</button>
        </div>

        <div id="cvr-cart-ok" style="display:none">Aggiunto al carrello! <a href="/cart">Vai al carrello</a></div>
      </div>
    </div>

    <!-- Toast notifiche -->
    <div id="cvr-toast" role="alert"></div>

    <input type="file" id="cvr-file-input" accept="image/jpeg,image/png,image/webp" style="display:none" />
  </div>
</div>`;
  }

  /* ══════════════════════════════════════════════
     CSS
  ══════════════════════════════════════════════ */
  function injectCSS() {
    const css = `
#cvr-root {
  position: fixed; inset: 0; z-index: 999999;
  display: none; align-items: center; justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, sans-serif;
}
#cvr-root.open { display: flex; }
#cvr-backdrop {
  position: absolute; inset: 0;
  background: rgba(0,0,0,0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
#cvr-modal {
  position: relative; z-index: 1;
  background: #fff;
  border-radius: 20px;
  width: min(980px, 96vw);
  max-height: 92vh;
  display: flex; flex-direction: column;
  box-shadow: 0 32px 100px rgba(0,0,0,0.35);
  overflow: hidden;
}
/* Header */
#cvr-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 24px;
  background: #111; color: #fff;
  flex-shrink: 0;
}
#cvr-header-left { display: flex; align-items: center; gap: 12px; }
#cvr-logo { font-size: 24px; }
#cvr-title { font-size: 16px; font-weight: 700; letter-spacing: 0.3px; }
#cvr-subtitle { font-size: 11px; color: rgba(255,255,255,0.5); margin-top: 1px; }
#cvr-close {
  background: rgba(255,255,255,0.12); border: none; color: #fff;
  width: 34px; height: 34px; border-radius: 50%;
  cursor: pointer; font-size: 16px; display: flex;
  align-items: center; justify-content: center;
  transition: background .2s;
}
#cvr-close:hover { background: rgba(255,255,255,0.25); }
/* Progress bar */
#cvr-progress-bar {
  height: 3px; background: #e0e0e0; flex-shrink: 0;
  display: none;
}
#cvr-progress-bar.active { display: block; }
#cvr-progress-fill {
  height: 100%; background: #111; width: 0%;
  transition: width 0.5s ease;
  border-radius: 0 2px 2px 0;
}
/* Body */
#cvr-body {
  display: grid; grid-template-columns: 1fr 320px;
  overflow: hidden; flex: 1; min-height: 0;
}
/* Colonna sinistra */
#cvr-left {
  background: #f5f5f5;
  display: flex; align-items: center; justify-content: center;
  padding: 24px; overflow: hidden;
}
#cvr-photo-area {
  position: relative; width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
}
/* Upload zone */
#cvr-upload-zone {
  display: flex; flex-direction: column; align-items: center;
  gap: 10px; text-align: center; cursor: pointer;
  padding: 40px 30px;
  border: 2px dashed #ccc; border-radius: 16px;
  transition: border-color .2s, background .2s;
  background: #fff;
}
#cvr-upload-zone:hover { border-color: #111; background: #fafafa; }
#cvr-upload-zone.drag-over { border-color: #111; background: #f0f0f0; }
#cvr-upload-icon { font-size: 48px; }
#cvr-upload-title { font-size: 16px; font-weight: 700; color: #111; }
#cvr-upload-sub { font-size: 13px; color: #888; }
#cvr-upload-btn {
  margin-top: 6px; padding: 12px 28px;
  background: #111; color: #fff; border: none;
  border-radius: 30px; font-size: 14px; font-weight: 600;
  cursor: pointer; transition: background .2s;
}
#cvr-upload-btn:hover { background: #333; }
#cvr-upload-hint { font-size: 11px; color: #bbb; }
/* Foto utente */
#cvr-user-photo {
  max-width: 100%; max-height: 100%;
  border-radius: 12px; object-fit: contain;
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
}
/* Loading */
#cvr-loading {
  display: flex; flex-direction: column; align-items: center;
  gap: 14px; text-align: center;
}
#cvr-spinner-ring {
  width: 52px; height: 52px;
  border: 4px solid #e0e0e0;
  border-top-color: #111;
  border-radius: 50%;
  animation: cvr-spin 0.9s linear infinite;
}
@keyframes cvr-spin { to { transform: rotate(360deg); } }
#cvr-loading-title { font-size: 15px; font-weight: 700; color: #111; }
#cvr-loading-sub { font-size: 13px; color: #888; }
/* Risultato */
#cvr-result-area {
  position: relative; display: flex;
  align-items: center; justify-content: center;
  width: 100%; height: 100%;
}
#cvr-result-img {
  max-width: 100%; max-height: 100%;
  border-radius: 12px; object-fit: contain;
  box-shadow: 0 8px 30px rgba(0,0,0,0.15);
}
#cvr-result-badge {
  position: absolute; top: 12px; left: 12px;
  background: #111; color: #fff;
  padding: 5px 12px; border-radius: 20px;
  font-size: 12px; font-weight: 600;
}
#cvr-retry-btn {
  position: absolute; bottom: 12px; left: 50%; transform: translateX(-50%);
  background: rgba(0,0,0,0.7); color: #fff; border: none;
  padding: 9px 20px; border-radius: 20px;
  font-size: 13px; cursor: pointer; transition: background .2s;
}
#cvr-retry-btn:hover { background: #111; }
/* Colonna destra */
#cvr-right {
  display: flex; flex-direction: column;
  border-left: 1px solid #f0f0f0;
  overflow-y: auto; padding: 22px 18px; gap: 18px;
}
.cvr-label {
  font-size: 10px; font-weight: 700; letter-spacing: 1.2px;
  color: #999; margin-bottom: 8px;
}
#cvr-product-name { font-size: 15px; font-weight: 600; color: #111; margin-bottom: 8px; }
#cvr-thumbs { display: flex; gap: 8px; flex-wrap: wrap; }
.cvr-thumb {
  width: 56px; height: 56px; border-radius: 8px;
  overflow: hidden; cursor: pointer; border: 2px solid transparent;
  transition: border-color .2s;
}
.cvr-thumb.active { border-color: #111; }
.cvr-thumb img { width: 100%; height: 100%; object-fit: cover; }
#cvr-sizes { display: flex; gap: 8px; flex-wrap: wrap; }
.cvr-size-btn {
  padding: 8px 16px; border: 1.5px solid #ddd;
  border-radius: 6px; background: #fff;
  font-size: 13px; cursor: pointer; transition: all .15s;
  color: #111;
}
.cvr-size-btn:hover { border-color: #111; }
.cvr-size-btn.selected { background: #111; color: #fff; border-color: #111; }
.cvr-size-btn:disabled { opacity: 0.35; cursor: not-allowed; }
#cvr-guide-table { width: 100%; border-collapse: collapse; font-size: 12px; }
#cvr-guide-table th, #cvr-guide-table td {
  padding: 6px 8px; text-align: center;
  border-bottom: 1px solid #f0f0f0; color: #555;
}
#cvr-guide-table th { background: #f8f8f8; color: #111; font-weight: 700; font-size: 11px; }
#cvr-actions { display: flex; flex-direction: column; gap: 10px; margin-top: auto; }
#cvr-add-cart {
  width: 100%; padding: 14px;
  background: #111; color: #fff;
  border: none; border-radius: 10px;
  font-size: 15px; font-weight: 600;
  cursor: pointer; transition: background .2s;
}
#cvr-add-cart:hover:not(:disabled) { background: #333; }
#cvr-add-cart:disabled { background: #ccc; cursor: not-allowed; }
#cvr-save {
  width: 100%; padding: 12px;
  background: #fff; color: #111;
  border: 1.5px solid #111; border-radius: 10px;
  font-size: 14px; font-weight: 600;
  cursor: pointer; transition: all .2s;
}
#cvr-save:hover { background: #f5f5f5; }
#cvr-cart-ok {
  font-size: 13px; color: #2a7a2a;
  text-align: center; padding: 10px;
  background: #f0fff0; border-radius: 8px;
}
#cvr-cart-ok a { color: #2a7a2a; font-weight: 600; }
/* Toast */
#cvr-toast {
  position: absolute; bottom: 20px; left: 50%;
  transform: translateX(-50%) translateY(100px);
  background: #333; color: #fff;
  padding: 12px 24px; border-radius: 12px;
  font-size: 14px; max-width: 90%;
  text-align: center; opacity: 0;
  transition: transform .3s ease, opacity .3s ease;
  pointer-events: none; z-index: 10;
  box-shadow: 0 8px 30px rgba(0,0,0,0.3);
}
#cvr-toast.show {
  transform: translateX(-50%) translateY(0);
  opacity: 1;
}
#cvr-toast.error { background: #d32f2f; }
/* Scrollbar */
#cvr-right::-webkit-scrollbar { width: 4px; }
#cvr-right::-webkit-scrollbar-track { background: transparent; }
#cvr-right::-webkit-scrollbar-thumb { background: #ddd; border-radius: 4px; }
/* Responsive */
@media (max-width: 700px) {
  #cvr-modal { border-radius: 0; width: 100vw; max-height: 100vh; height: 100vh; }
  #cvr-body { grid-template-columns: 1fr; grid-template-rows: 1fr auto; }
  #cvr-left { min-height: 280px; padding: 16px; }
  #cvr-right { max-height: 45vh; padding: 16px 14px; }
  #cvr-header { padding: 14px 16px; }
  #cvr-guide-section { display: none; }
}
    `;
    const style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ══════════════════════════════════════════════
     TOAST (sostituisce alert())
  ══════════════════════════════════════════════ */
  let toastTimer = null;
  function showToast(msg, isError = false, duration = 5000) {
    const el = document.getElementById("cvr-toast");
    if (!el) return;
    el.textContent = msg;
    el.className = isError ? "show error" : "show";
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.className = ""; }, duration);
  }

  /* ══════════════════════════════════════════════
     PROGRESS BAR
  ══════════════════════════════════════════════ */
  let progressInterval = null;
  function startProgress() {
    const bar  = document.getElementById("cvr-progress-bar");
    const fill = document.getElementById("cvr-progress-fill");
    if (!bar || !fill) return;
    bar.classList.add("active");
    fill.style.width = "0%";
    let pct = 0;
    progressInterval = setInterval(() => {
      // Avanza veloce all'inizio, poi rallenta
      if (pct < 30) pct += 2;
      else if (pct < 60) pct += 0.8;
      else if (pct < 85) pct += 0.3;
      else if (pct < 95) pct += 0.1;
      fill.style.width = pct + "%";
    }, 500);
  }

  function stopProgress(success) {
    clearInterval(progressInterval);
    const bar  = document.getElementById("cvr-progress-bar");
    const fill = document.getElementById("cvr-progress-fill");
    if (!bar || !fill) return;
    fill.style.width = success ? "100%" : "0%";
    setTimeout(() => {
      bar.classList.remove("active");
      fill.style.width = "0%";
    }, success ? 600 : 200);
  }

  /* ══════════════════════════════════════════════
     INIT
  ══════════════════════════════════════════════ */
  async function init() {
    try {
      const resp = await fetch(`${API_HOST}/api/admin/status`, { method: "GET" });
      if (resp.ok) {
        const data = await resp.json();
        if (!data.enabled) {
          console.log("[CVR] App disabilitata");
          return;
        }
      }
    } catch (e) {
      console.warn("[CVR] Status check fallito:", e.message);
    }

    injectCSS();
    document.body.insertAdjacentHTML("beforeend", buildHTML());
    bindEvents();
    injectProductButton();
  }

  /* ══════════════════════════════════════════════
     EVENTI
  ══════════════════════════════════════════════ */
  function bindEvents() {
    const $ = (id) => document.getElementById(id);

    $("cvr-close").addEventListener("click", closeModal);
    $("cvr-backdrop").addEventListener("click", closeModal);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeModal(); });

    $("cvr-upload-zone").addEventListener("click", () => $("cvr-file-input").click());
    $("cvr-upload-btn").addEventListener("click", (e) => { e.stopPropagation(); $("cvr-file-input").click(); });
    $("cvr-file-input").addEventListener("change", onFileSelected);

    // Drag & drop con feedback visivo
    const zone = $("cvr-upload-zone");
    zone.addEventListener("dragover", (e) => { e.preventDefault(); zone.classList.add("drag-over"); });
    zone.addEventListener("dragleave", () => zone.classList.remove("drag-over"));
    zone.addEventListener("drop", (e) => {
      e.preventDefault();
      zone.classList.remove("drag-over");
      const file = e.dataTransfer.files[0];
      if (file) processFile(file);
    });

    $("cvr-retry-btn").addEventListener("click", resetPhoto);
    $("cvr-add-cart").addEventListener("click", addToCart);
    $("cvr-save").addEventListener("click", savePhoto);
  }

  /* ══════════════════════════════════════════════
     APRI / CHIUDI
  ══════════════════════════════════════════════ */
  function openModal(product) {
    state.product = product;
    const $ = (id) => document.getElementById(id);
    $("cvr-product-name").textContent = product.title || "";
    renderThumbs(product.images || []);
    renderSizes(product.variants || []);
    $("cvr-root").classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    document.getElementById("cvr-root").classList.remove("open");
    document.body.style.overflow = "";
  }

  /* ══════════════════════════════════════════════
     THUMBNAILS
  ══════════════════════════════════════════════ */
  function renderThumbs(images) {
    const container = document.getElementById("cvr-thumbs");
    container.innerHTML = "";
    images.slice(0, 5).forEach((img, i) => {
      const div = document.createElement("div");
      div.className = "cvr-thumb" + (i === 0 ? " active" : "");
      div.innerHTML = `<img src="${img.src_thumb || img.src}" alt="" loading="lazy" />`;
      div.addEventListener("click", () => {
        document.querySelectorAll(".cvr-thumb").forEach(t => t.classList.remove("active"));
        div.classList.add("active");
        state.product.currentImageUrl = img.src;
        if (state.photoFile && !state.loading) runAITryon(img.src);
      });
      container.appendChild(div);
    });
  }

  /* ══════════════════════════════════════════════
     TAGLIE
  ══════════════════════════════════════════════ */
  function renderSizes(variants) {
    const container = document.getElementById("cvr-sizes");
    container.innerHTML = "";
    const seen = new Set();
    variants.forEach(v => {
      const size = v.size || v.title;
      if (!size || seen.has(size)) return;
      seen.add(size);
      const btn = document.createElement("button");
      btn.className = "cvr-size-btn";
      btn.textContent = size;
      btn.disabled = !v.available;
      btn.type = "button";
      btn.addEventListener("click", () => {
        document.querySelectorAll(".cvr-size-btn").forEach(b => b.classList.remove("selected"));
        btn.classList.add("selected");
        state.product.selectedVariantId = v.id;
        document.getElementById("cvr-add-cart").disabled = false;
      });
      container.appendChild(btn);
    });
  }

  /* ══════════════════════════════════════════════
     FILE HANDLING
  ══════════════════════════════════════════════ */
  function onFileSelected(e) {
    const file = e.target.files[0];
    e.target.value = "";
    if (file) processFile(file);
  }

  function processFile(file) {
    const allowed = ["image/jpeg", "image/png", "image/webp"];
    if (!allowed.includes(file.type)) {
      showToast("Formato non supportato. Usa JPG, PNG o WEBP.", true);
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      showToast("Foto troppo grande. Massimo 10MB.", true);
      return;
    }

    state.photoFile = file;
    const reader = new FileReader();
    reader.onload = (e) => {
      state.photoDataUrl = e.target.result;
      showUserPhoto(e.target.result);
      const garmentUrl = state.product?.currentImageUrl || state.product?.images?.[0]?.src;
      if (garmentUrl) runAITryon(garmentUrl);
    };
    reader.readAsDataURL(file);
  }

  function showUserPhoto(dataUrl) {
    const $ = (id) => document.getElementById(id);
    $("cvr-upload-zone").style.display = "none";
    $("cvr-result-area").style.display = "none";
    const img = $("cvr-user-photo");
    img.src = dataUrl;
    img.style.display = "block";
  }

  /* ══════════════════════════════════════════════
     AI TRY-ON
  ══════════════════════════════════════════════ */
  async function runAITryon(garmentUrl) {
    if (!state.photoFile || state.loading) return;
    state.loading = true;

    const $ = (id) => document.getElementById(id);
    $("cvr-user-photo").style.display  = "none";
    $("cvr-result-area").style.display = "none";
    $("cvr-loading").style.display     = "flex";
    $("cvr-save").style.display        = "none";
    $("cvr-loading-title").textContent = "L'AI sta elaborando…";
    $("cvr-loading-sub").textContent   = "Circa 30-60 secondi";

    startProgress();

    try {
      const formData = new FormData();
      formData.append("userPhoto", state.photoFile);
      formData.append("productImageUrl", garmentUrl);
      if (state.product?.title) {
        formData.append("productTitle", state.product.title);
      }

      const resp = await fetch(`${API_HOST}/api/fitting/try-on`, {
        method: "POST",
        body: formData,
      });

      if (!resp.ok) {
        const errData = await resp.json().catch(() => ({}));
        throw new Error(errData.error || errData.detail || `Errore server: ${resp.status}`);
      }
      const data = await resp.json();
      if (!data.success) throw new Error(data.error || "Elaborazione non riuscita");

      stopProgress(true);

      if (data.resultBase64) {
        state.resultUrl    = `${API_HOST}${data.resultUrl}`;
        state.resultBase64 = data.resultBase64;
        showResultBase64(data.resultBase64);
      } else if (data.resultUrl) {
        state.resultUrl = `${API_HOST}${data.resultUrl}`;
        showResult(state.resultUrl);
      } else {
        throw new Error("Nessun risultato ricevuto");
      }

    } catch (err) {
      console.error("[CVR] Errore:", err);
      stopProgress(false);
      $("cvr-loading").style.display = "none";
      $("cvr-user-photo").style.display = "block";
      showToast(err.message || "Errore durante l'elaborazione. Riprova.", true, 6000);
    } finally {
      state.loading = false;
    }
  }

  /* ══════════════════════════════════════════════
     MOSTRA RISULTATO
  ══════════════════════════════════════════════ */
  function showResultBase64(base64DataUri) {
    const $ = (id) => document.getElementById(id);
    const img = $("cvr-result-img");
    img.onload = () => {
      $("cvr-loading").style.display     = "none";
      $("cvr-user-photo").style.display  = "none";
      $("cvr-result-area").style.display = "flex";
      $("cvr-save").style.display        = "block";
    };
    img.onerror = () => {
      $("cvr-loading").style.display    = "none";
      $("cvr-user-photo").style.display = "block";
      showToast("Errore nel mostrare il risultato. Riprova.", true);
    };
    img.src = base64DataUri;
  }

  async function showResult(url) {
    const $ = (id) => document.getElementById(id);
    try {
      const resp = await fetch(url);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const blob = await resp.blob();
      const objectUrl = URL.createObjectURL(blob);
      const img = $("cvr-result-img");
      img.onload = () => {
        $("cvr-loading").style.display     = "none";
        $("cvr-user-photo").style.display  = "none";
        $("cvr-result-area").style.display = "flex";
        $("cvr-save").style.display        = "block";
      };
      img.src = objectUrl;
    } catch (err) {
      console.error("[CVR] showResult error:", err);
      $("cvr-loading").style.display    = "none";
      $("cvr-user-photo").style.display = "block";
      showToast("Impossibile caricare il risultato. Riprova.", true);
    }
  }

  /* ══════════════════════════════════════════════
     RESET / CARRELLO / SALVA
  ══════════════════════════════════════════════ */
  function resetPhoto() {
    const $ = (id) => document.getElementById(id);
    state.photoFile = null;
    state.photoDataUrl = null;
    state.resultUrl = null;
    state.resultBase64 = null;
    $("cvr-user-photo").style.display  = "none";
    $("cvr-result-area").style.display = "none";
    $("cvr-loading").style.display     = "none";
    $("cvr-upload-zone").style.display = "flex";
    $("cvr-save").style.display        = "none";
    $("cvr-cart-ok").style.display     = "none";
  }

  async function addToCart() {
    if (!state.product?.selectedVariantId) {
      showToast("Seleziona prima una taglia.", true);
      return;
    }
    const btn = document.getElementById("cvr-add-cart");
    btn.disabled = true;
    btn.textContent = "Aggiunta…";
    try {
      const resp = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: state.product.selectedVariantId, quantity: 1 }),
      });
      if (!resp.ok) throw new Error();
      document.getElementById("cvr-cart-ok").style.display = "block";
      btn.textContent = "Aggiunto!";
      showToast("Prodotto aggiunto al carrello");
      document.dispatchEvent(new CustomEvent("cart:updated"));
    } catch {
      showToast("Errore aggiunta al carrello. Riprova.", true);
      btn.disabled = false;
      btn.textContent = "Aggiungi al carrello";
    }
  }

  async function savePhoto() {
    try {
      let url;
      if (state.resultBase64) {
        const res  = await fetch(state.resultBase64);
        const blob = await res.blob();
        url = URL.createObjectURL(blob);
      } else if (state.resultUrl) {
        const res  = await fetch(state.resultUrl);
        const blob = await res.blob();
        url = URL.createObjectURL(blob);
      } else {
        showToast("Nessun risultato da salvare.", true);
        return;
      }
      const a = document.createElement("a");
      a.href = url;
      a.download = "camerino-virtuale.jpg";
      a.click();
      URL.revokeObjectURL(url);
      showToast("Foto salvata!");
    } catch {
      showToast("Impossibile salvare la foto.", true);
    }
  }

  /* ══════════════════════════════════════════════
     INIETTA PULSANTE PRODOTTO
  ══════════════════════════════════════════════ */
  function injectProductButton() {
    const productJson = window.ShopifyAnalytics?.meta?.product;
    if (!productJson) return;

    // Titolo da fonti multiple
    const productTitle =
      productJson.title ||
      window.meta?.product?.title ||
      document.querySelector('h1.product__title, h1.product-title, h1[itemprop="name"], .product__title h1, .product-single__title')?.textContent?.trim() ||
      document.querySelector('meta[property="og:title"]')?.content?.replace(/\s*[|\-\u2013].*$/, "").trim() ||
      document.title?.replace(/\s*[|\-\u2013].*$/, "").trim() ||
      "";

    const product = {
      id:              productJson.id,
      title:           productTitle,
      handle:          productJson.handle,
      images:          (productJson.images || []).map(src => ({ src, src_thumb: src })),
      currentImageUrl: productJson.images?.[0] || "",
      variants:        (productJson.variants || []).map(v => ({
        id: v.id, title: v.title,
        size: v.option1, color: v.option2,
        available: v.available,
      })),
    };

    const forms = document.querySelectorAll("form[action='/cart/add']");
    forms.forEach(form => {
      if (form.querySelector(".cvr-inject-btn")) return;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cvr-inject-btn";
      btn.textContent = "Prova nel Camerino Virtuale";
      btn.style.cssText = `
        width: 100%; padding: 14px; margin-top: 12px;
        background: #111; color: #fff; border: none;
        border-radius: 8px; font-size: 15px; font-weight: 600;
        cursor: pointer; transition: background .2s;
      `;
      btn.onmouseover = () => btn.style.background = "#333";
      btn.onmouseout  = () => btn.style.background = "#111";
      btn.addEventListener("click", () => openModal(product));
      const submit = form.querySelector("[type=submit]");
      if (submit) submit.parentNode.insertBefore(btn, submit.nextSibling);
      else form.appendChild(btn);
    });
  }

  /* ══════════════════════════════════════════════
     API PUBBLICA
  ══════════════════════════════════════════════ */
  window.VirtualFittingRoom = { open: openModal, close: closeModal };

  /* ══════════════════════════════════════════════
     AVVIO
  ══════════════════════════════════════════════ */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
